const topics = [
  { name: '韩漫推荐', heat: '9.8万讨论', tag: '热门', color: 'primary' },
  { name: '完结日漫', heat: '7.2万讨论', tag: '经典', color: 'accent' },
  { name: '国漫崛起', heat: '6.5万讨论', tag: '新番', color: 'primary' },
  { name: '恋爱甜漫', heat: '8.1万讨论', tag: '人气', color: 'accent' },
  { name: '悬疑推理', heat: '5.3万讨论', tag: '热追', color: 'primary' },
  { name: '穿越题材', heat: '6.8万讨论', tag: '热榜', color: 'accent' },
  { name: '热血少年', heat: '7.5万讨论', tag: '经典', color: 'primary' },
  { name: '都市言情', heat: '4.9万讨论', tag: '新番', color: 'accent' },
  { name: '搞笑日常', heat: '5.6万讨论', tag: '热门', color: 'primary' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
            话题热榜
          </h2>
          <p className="text-sm text-foreground-500">虫虫漫画读者最关注的热门话题与讨论风向</p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {topics.map((topic) => (
            <div
              key={topic.name}
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer group"
            >
              <span
                className={`text-[10px] font-semibold px-1.5 py-0.5 rounded-full whitespace-nowrap ${
                  topic.color === 'primary'
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-accent-100 text-accent-700'
                }`}
              >
                {topic.tag}
              </span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}